var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('el-dialog',{staticClass:"pcDialog",attrs:{"close-on-click-modal":false,"title":"提示","visible":_vm.dialogShow,"width":"250px"},on:{"update:visible":function($event){_vm.dialogShow=$event}}},[_c('span',[_vm._v("不支持移动端，请在电脑端查看")]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b098e3f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 